import React, { useEffect, useRef, useCallback  } from "react";
import { toast, ToastContainer } from "react-toastify";

// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { annonceAdded, annonceGetById, saveImageAnnonce } from "../../../Redux/annonceReduce";
import { useTranslation } from 'react-multi-lang'
import { useDispatch } from "react-redux";
import { verification } from "../../../Redux/usersReduce";

function AjouterActualite({client}) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const t = useTranslation();
  var annee = localStorage.getItem("annee");
  var id = 0
  if (isNaN(location.id) === true) document.title = t("Actualite.add");
  else {
    id = location.id;
    document.title = t("Actualite.update");
  }
  const [titre, setTitre] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [descriptionEn, setDescriptionEn] = React.useState("");
  const [titreEn, setTitreEn] = React.useState("");
  const [datePub, setDatePub] = React.useState(null);
  const [order, setOrder] = React.useState(0);
  const [file, setFile] = React.useState(null);
  const [fileNames, setFileNames] = React.useState(null);
  const [uploadFile, setUploadFile] = React.useState(null);
  const saveCalled = useRef(false);

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }

  function uploadImage(event) {
    let ImageFile = event.target.files[0];
    if (ImageFile) {
      setFile(ImageFile);
      setFileNames(event.target.files[0].name);
    }
  }

  function submitForm(event) {
    if (
      titre !== "" &&
      titreEn !== "" &&
      description !== "" &&
      descriptionEn !== "" &&
      datePub !== null &&
      order > 0
    ) {
      if (isNaN(location.id) === true) {
        if (file !== null) {
          const dataArray = new FormData();
          dataArray.append("file", file);
          dataArray.append("name", file.name);
          if (saveCalled.current) return;
          saveCalled.current = true;
          dispatch(saveImageAnnonce(dataArray))
            .then((val) => {
              var filename = val.payload.filename;
              dispatch(
                annonceAdded({
                  filename,
                  titre,
                  titre_en: titreEn,
                  description,
                  description_en: descriptionEn,
                  date_pub: datePub,
                  order,
                  id,
                  type: 1
                  , annee: annee,client
                })
              )
                .then((e) => {
                  if (e.payload == true) {
                    notify(1, t("add_txt"));
                    setTimeout(async () => {
                      navigate.push(client+"/listActualite");
                    }, 800);
                  } else {
                    notify(2, t("problem"));
                    saveCalled.current = false;
                  }
                })
                .catch((error) => {
                  notify(2, t("erreur_add"));
                  console.error("Error updating actualite:", error);
                });
            })
            .catch((error) => {
              notify(2, t("erreur_add"));
              console.error("Error updating actualite:", error);
            });
        } else {
          notify(2, t("Actualite.required"));
        }
      } else {
        if (file != null) {
          const dataArray = new FormData();
          dataArray.append("file", file);
          dataArray.append("name", file.name);
          if (saveCalled.current) return;
          saveCalled.current = true;
          dispatch(saveImageAnnonce(dataArray))
            .then((val) => {
              var filename = val.payload.filename;
              dispatch(
                annonceAdded({
                  filename,
                  titre,
                  titre_en: titreEn,
                  description,
                  description_en: descriptionEn,
                  date_pub: datePub,
                  order,
                  id,
                  type: 1,
                  annee: annee,client
                })
              )
                .then((e) => {
                  if (e.payload == true) {
                    notify(1, t("add_txt"));
                    setTimeout(async () => {
                      navigate.push(client+"/listActualite");
                    }, 800);
                  } else {
                    notify(2, t("problem"));
                    saveCalled.current = false;
                  }
                })
                .catch((error) => {
                  notify(2, t("erreur_add"));
                  console.error("Error updating actualite:", error);
                });
            })
            .catch((error) => {
              notify(2, t("erreur_add"));
              console.error("Error updating actualite:", error);
            });
        } else {
          if (saveCalled.current) return;
          saveCalled.current = true;
          dispatch(
            annonceAdded({
              filename: fileNames,
              titre,
              titre_en: titreEn,
              description,
              description_en: descriptionEn,
              date_pub: datePub,
              order,
              id,
              type: 1,
              annee: annee,client
            })
          )
            .then((e) => {
              if (e.payload == true) {
                notify(1, t("add_txt"));
                setTimeout(async () => {
                  navigate.push(client+"/listActualite");
                }, 800);
              } else {
                notify(2, t("problem"));
                saveCalled.current = false
              }
            })
            .catch((error) => {
              notify(2, t("erreur_add"));
              console.error("Error updating actualite:", error);
            });
        }
      }
    } else {
      notify(2, t("Actualite.required"));
    }
  }


  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);
  
  useEffect(() => {
    verifToken()
    async function getActualite() {
      if (isNaN(location.id) === false) {
        var actualite = await dispatch(annonceGetById(location.id));
        var entities = actualite.payload;
        if (entities === false) {
          navigate.push(client+'/listActualite');
        }
        else {
          setDatePub(entities.date_pub);
          setFileNames(entities.image);
          setOrder(entities.order);
          setTitre(entities.titre);
          setTitreEn(entities.titre_en);
          setDescription(entities.description);
          setDescriptionEn(entities.description_en);
        }
      }
    }
    getActualite();
  }, [location.id, dispatch, navigate]);

  function listeActualite() {
    navigate.push(client+'/listActualite');
  }
  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeActualite}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t('list')}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      {typeof location.id == "undefined"
                        ? t('Actualite.add')
                        : t('Actualite.update')}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t('titre')} * </label>
                          <Form.Control
                            defaultValue={titre}
                            placeholder={t('titre')}
                            type="text"
                            onChange={(value) => {
                              setTitre(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>{t('titre')} En* </label>
                          <Form.Control
                            defaultValue={titreEn}
                            placeholder={t('titre') + " En"}
                            type="text"
                            onChange={(value) => {
                              setTitreEn(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t('description')} * </label>
                          <Form.Control
                            style={{ height: "150px" }}
                            defaultValue={description}
                            placeholder={t('description')}
                            as="textarea"
                            onChange={(value) => {
                              setDescription(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>{t('description')} En* </label>
                          <Form.Control
                            style={{ height: "150px" }}
                            defaultValue={descriptionEn}
                            placeholder={t('description') + " En"}
                            as="textarea"
                            onChange={(value) => {
                              setDescriptionEn(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t('date_pub')} * </label>
                          <Form.Control
                            defaultValue={datePub}
                            placeholder={t('date_pub')}
                            type="date"
                            onChange={(value) => {
                              setDatePub(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>{t('order_apperance')} * </label>
                          <Form.Control
                            value={order}
                            placeholder={t('order_apperance')}
                            type="number"
                            onChange={(value) => {
                              setOrder(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t('image')} *</label>
                          <div className="custom-file">
                            <Form.Control
                              id="test"
                              name="file"
                              type="file"
                              accept="image/png, image/jpeg, image/jpg"
                              onChange={(e) => uploadImage(e)}
                              className="custom-file-input"
                            />
                            <label className="custom-file-label" htmlFor="test">
                              {fileNames ? fileNames : t("Choose_file")}
                            </label>
                          </div>
                        </Form.Group>
                      </Col>

                    </Row>
                    <Button
                      className="btn-fill pull-right"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                    >
                      {t('save')}
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container >
    </>
  );
}

export default AjouterActualite;
